(function () {

  // ── Remove all variants of the same product from the cart ──
  function removeAllVariantsOfProduct(productId) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (String(item.product_id) === String(productId)) {
            updates[item.variant_id] = 0;
          }
        });

        if (Object.keys(updates).length === 0) return;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function (updatedCart) {
            var bubble = document.querySelector(
              '#cart-icon-bubble .cart-count-bubble span[aria-hidden]'
            );
            if (bubble) bubble.textContent = updatedCart.item_count;

            fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var parser          = new DOMParser();
                var doc             = parser.parseFromString(html, 'text/html');
                var newCartDrawer     = doc.querySelector('cart-drawer');
                var currentCartDrawer = document.querySelector('cart-drawer');

                if (newCartDrawer && currentCartDrawer) {
                  currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                  if (updatedCart.item_count > 0) {
                    currentCartDrawer.classList.remove('is-empty');
                  } else {
                    currentCartDrawer.classList.add('is-empty');
                  }
                }
              })
              .catch(function (err) {
                console.error('Wholesale: cart remove refresh error', err);
              });
          })
          .catch(function (err) {
            console.error('Wholesale: cart update error', err);
          });
      })
      .catch(function (err) {
        console.error('Wholesale: cart fetch error', err);
      });
  }

  // ── Intercept clicks on remove buttons for wholesale items ──
  function initWholesaleCartRemove() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-remove-button');
      if (!btn) return;

      var isWholesale = btn.dataset.isWholesale === 'true';
      if (!isWholesale) return;

      var productId = btn.dataset.productId;
      if (!productId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      removeAllVariantsOfProduct(productId);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWholesaleCartRemove);
  } else {
    initWholesaleCartRemove();
  }

})();
